import Full from './full.vue';
import MobFull from './mob-full.vue';
import Pure from './pure.vue';
import MobPure from './mob-pure.vue';
import Overview from '@rebuild/materials/shared/announcement/OverviewIndex.vue';
import MobOverview from '@rebuild/materials/shared/announcement/mobile/MobOverviewIndex.vue';
import { withProvider } from '@rebuild/hooks/useCompWithProvider';
import { provideCurrentContext } from '@rebuild/materials/shared/announcement/context';

function useSelfContext() {
	provideCurrentContext();
}

export const componentMap = {
	overview: withProvider(Overview, useSelfContext),
	full: withProvider(Full, useSelfContext),
	'mob-overview': withProvider(MobOverview, useSelfContext),
	'mob-full': withProvider(MobFull, useSelfContext),

	// pure 简览外链：展示前八条，高度交由消费方控制
	pure: withProvider(Pure, useSelfContext),
	'mob-pure': withProvider(MobPure, useSelfContext)
};
